import { MetaError } from '@/lib/errors/meta/meta-error'

export class FlightNotFoundError extends MetaError {
  constructor(metadata?: Record<string, unknown>, message?: string) {
    super(null, metadata, message ?? 'Flight not found')
  }
}
